import { render } from "./AllSlides.vue?vue&type=template&id=acc8fcf8&scoped=true"
import script from "./AllSlides.vue?vue&type=script&lang=js"
export * from "./AllSlides.vue?vue&type=script&lang=js"

import "./AllSlides.vue?vue&type=style&index=0&id=acc8fcf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acc8fcf8"]])

export default __exports__